import React from 'react';
import { Trophy, PiggyBank, Settings } from 'lucide-react';

interface ScenarioCardProps {
  icon: React.ReactNode;
  step: string;
  title: string;
  description: string;
  highlighted?: boolean;
}

const ScenarioCard: React.FC<ScenarioCardProps> = ({ icon, step, title, description, highlighted }) => (
  <div className={`relative rounded-xl p-8 transition-shadow duration-200 ${
    highlighted
      ? 'bg-blue-600 text-white shadow-lg'
      : 'bg-white border border-gray-200 shadow-sm hover:shadow-md'
  }`}>
    <div className={`text-xs font-semibold uppercase tracking-wider mb-4 ${
      highlighted ? 'text-blue-200' : 'text-blue-500'
    }`}>
      {step}
    </div>
    <div className={`flex items-center justify-center w-14 h-14 rounded-xl mb-6 ${
      highlighted ? 'bg-white/20' : 'bg-blue-50'
    }`}>
      {icon}
    </div>
    <h3 className={`text-xl font-bold mb-4 ${highlighted ? 'text-white' : 'text-gray-900'}`}>
      {title}
    </h3>
    <p className={`leading-relaxed ${highlighted ? 'text-blue-100' : 'text-gray-600'}`}>
      {description}
    </p>
  </div>
);

export const ProScenarios: React.FC = () => {
  return (
    <section id="scenarios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
            Trois façons de générer un scénario, selon votre besoin.
          </h2>
          <div className="w-12 h-0.5 bg-blue-500 mb-6"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <ScenarioCard
            step="Scénario 01"
            icon={<Trophy className="w-7 h-7 text-blue-600" />}
            title="Meilleure lettre"
            description="Un clic. DPEWizard génère le scénario qui permet d'atteindre la meilleure classe énergétique possible pour ce bien. Pour les clients qui veulent aller au maximum sans se poser de questions."
          />
          <ScenarioCard
            step="Scénario 02"
            icon={<PiggyBank className="w-7 h-7 text-white" />}
            title="Meilleure rentabilité"
            description="Un clic. DPEWizard génère le scénario le plus économique pour sortir des lettres F ou G et atteindre une classe acceptable. Pour les clients qui veulent dépenser le strict nécessaire et sécuriser la valeur de leur bien."
            highlighted
          />
          <ScenarioCard
            step="Scénario 03"
            icon={<Settings className="w-7 h-7 text-blue-600" />}
            title="Sur mesure"
            description="Pour ceux qui veulent composer leur propre scénario poste par poste. Utile pour les profils plus expérimentés ou les situations complexes."
          />
        </div>
      </div>
    </section>
  );
};

export default ProScenarios;
